import React, {Component, Fragment} from "react";
import {Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import SFXButtonComponent from "./SFXButtonComponent";
import DropdownComponent from "./DropdownComponent";

const MINIMUM_YEAR = 1900;
const MAXIMUM_YEAR = 2100;

const MIN_YEAR_SUBSTRING_INDEX = 0;
const MAX_YEAR_SUBSTRING_INDEX = 4;

const MIN_MONTH_SUBSTRING_INDEX = 5;
const MAX_MONTH_SUBSTRING_INDEX = 7;

const MIN_DAY_SUBSTRING_INDEX = 8;
const MAX_DAY_SUBSTRING_INDEX = 10;

export default class DatePicker extends Component {

  constructor(props) {
    super(props);

    let minDate = MINIMUM_YEAR + "-01-01";
    let maxDate = MAXIMUM_YEAR + "-12-31";

    if (this.props.type) {
      let dates = this.getMinMaxByType(this.props.type, minDate, maxDate);
      minDate = dates["minDate"];
      maxDate = dates["maxDate"];
    } else {
      if (this.props.minDate) {
        minDate = this.props.minDate;
      }
      if (this.props.maxDate) {
        maxDate = this.props.maxDate;
      }
    }

    let initialDate = new Date();
    if (this.props.value) {
      initialDate = new Date(this.props.value);
    }

    let minDateProps = new Date(minDate)
    if (initialDate < minDateProps) {
      initialDate = minDateProps;
    }

    let maxDateProps = new Date(maxDate)
    if (initialDate > maxDateProps) {
      initialDate = maxDateProps;
    }

    let nowYear = initialDate.getFullYear();
    let nowMonth = initialDate.getMonth() + 1;
    let nowDay = initialDate.getDate();

    if (nowMonth < 10) nowMonth = "0" + nowMonth;
    if (nowDay < 10) nowDay = "0" + nowDay;

    let valueGroups = {
      year: nowYear.toString(),
      month: nowMonth.toString(),
      day: nowDay.toString()
    };

    this.limitMinDay = parseInt(minDate.substring(MIN_DAY_SUBSTRING_INDEX, MAX_DAY_SUBSTRING_INDEX), 10);
    this.limitMinMonth = parseInt(minDate.substring(MIN_MONTH_SUBSTRING_INDEX, MAX_MONTH_SUBSTRING_INDEX), 10);
    this.limitMinYear = parseInt(minDate.substring(MIN_YEAR_SUBSTRING_INDEX, MAX_YEAR_SUBSTRING_INDEX), 10);
    this.limitMaxDay = parseInt(maxDate.substring(MIN_DAY_SUBSTRING_INDEX, MAX_DAY_SUBSTRING_INDEX), 10);
    this.limitMaxMonth = parseInt(maxDate.substring(MIN_MONTH_SUBSTRING_INDEX, MAX_MONTH_SUBSTRING_INDEX), 10);
    this.limitMaxYear = parseInt(maxDate.substring(MIN_YEAR_SUBSTRING_INDEX, MAX_YEAR_SUBSTRING_INDEX), 10);

    this.state = {
      isOpen: false,
      valueGroups: valueGroups,
      showPlaceholder: true,
      optionGroups: {
        year: this.generateNumberArray(this.limitMinYear, this.limitMaxYear),
        month: this.generateNumberArray(1, 12, 2),
        day: this.generateNumberArray(1, 31, 2)
      }
    }
  }

  componentDidMount() {
    this.handleChange("year", this.state.valueGroups.year);
    this.handleChange("month", this.state.valueGroups.month);
  }

  getMinMaxByType(type, defaultMinDate, defaultMaxDate) {

    switch (type) {
      case "PAST":
        return {"minDate": defaultMinDate, "maxDate": this.formatDateString(new Date())};
      case "ID_EXPIRY":
        return {"minDate": this.formatDateString(new Date()), "maxDate": defaultMaxDate};
      default:
        return {"minDate": defaultMinDate, "maxDate": defaultMaxDate};
    }
  }

  formatDateString(unFormattedDate) {

    let dd = unFormattedDate.getDate();
    let mm = unFormattedDate.getMonth() + 1;
    let yy = unFormattedDate.getFullYear();

    return yy + "-" + (mm < 10 ? "0" : "") + mm + "-" + (dd < 10 ? "0" : "") + dd;
  }

  generateNumberArray(min, max) {
    let array = [];
    for (let i = min; i <= max; i++) {
      array.push(((i.toString().length === 1 && i < 10) ? '0' : '') + i);
    }
    return array;
  }

  getValue() {
    if (this.props.value !== "" && this.state.showPlaceholder) {
      return this.props.value;
    } else if (!this.state.showPlaceholder) {
      return (this.state.valueGroups.year + '-' + this.state.valueGroups.month + '-' + this.state.valueGroups.day)
    } else {
      return "";
    }
  }

  isLeapYear(yearValue) {
    return ((yearValue % 4 === 0 && yearValue % 100 !== 0) || (yearValue % 400 === 0));
  }


  handleChange(name, value) {
    this.setState(({valueGroups, optionGroups}) => {
        const nextState = {
          valueGroups: {
            ...valueGroups,
            [name]: value
          }
        };

        if (name === "year") {
          let yearValue = parseInt(value, 10)
          let minMonth = 1;
          let maxMonth = 12;
          if (yearValue === this.limitMinYear) {
            minMonth = this.limitMinMonth;
          }
          if (yearValue === this.limitMaxYear) {
            maxMonth = this.limitMaxMonth;
          }
          nextState.optionGroups = {
            ...optionGroups,
            month: this.generateNumberArray(minMonth, maxMonth),
            day: this.generateDayArray(value, valueGroups.month)
          };

        } else if (name === 'month') {

          nextState.optionGroups = {
            ...optionGroups,
            day: this.generateDayArray(valueGroups.year, value)
          };
        }

        return nextState;
      }
    )
    ;
  }

  generateDayArray(yearValueString, monthValueString) {

    let yearValue = parseInt(yearValueString, 10);
    let monthValue = parseInt(monthValueString, 10);

    let minDay = 1;
    let maxDay = 30;
    if (monthValueString === '02') {
      if (this.isLeapYear(yearValue)) {
        maxDay = 29;
      } else {
        maxDay = 28;
      }
    } else if (['01', '03', '05', '07', '08', '10', '12'].includes(monthValueString)) {
      maxDay = 31;
    }

    if (monthValue === this.limitMinMonth && yearValue === this.limitMinYear) {
      minDay = this.limitMinDay;
    }
    if (monthValue === this.limitMaxMonth && yearValue === this.limitMaxYear) {
      maxDay = this.limitMaxDay;
    }

    return this.generateNumberArray(minDay, maxDay);
  }

  onSetClick() {
    this.setState({
      isOpen: false,
      showPlaceholder: false
    }, () => {
      if (this.props.onChange) {
        this.props.onChange(this.getValue())
      }
      if (this.props.onBlur) {
        this.props.onBlur();
      }
    });
  }

  onCancelClick() {
    this.setState({
      isOpen: false
    }, this.props.onBlur);
  }

  render() {

    let value = this.props.value === "" ? this.getValue() : this.props.value;

    return <Fragment>
      <Input
        style={this.props.style}
        className={this.props.inputStyle}
        type={"text"}
        onClick={() => {
          this.setState({isOpen: true});
        }}
        onBlur={this.props.firstTouch}
        placeholder={this.props.placeholder}
        value={value}
        valid={this.props.valid}
        invalid={this.props.invalid}
        onChange={() => {}}
      />

      {this.state.isOpen && this.renderModal()}
    </Fragment>
  }

  renderModal() {
    return <Fragment>
      <Modal
        isOpen={true}
        toggle={this.onCancelClick.bind(this)}
      >
        <ModalHeader style={{justifyContent: "center"}}>Select Date</ModalHeader>
        <ModalBody className={"date_picker_modal_body"}>
          {
            <Fragment>
              {this.renderBrowserDatePicker()}
            </Fragment>
          }
        </ModalBody>
        <ModalFooter>
          <SFXButtonComponent
            className={"btn btn-success"}
            onClick={this.onSetClick.bind(this)}
          >Set</SFXButtonComponent>
          <SFXButtonComponent
            className={"btn btn-success"}
            onClick={this.onCancelClick.bind(this)}>Cancel</SFXButtonComponent>
        </ModalFooter>
      </Modal>
    </Fragment>

  }

  renderBrowserDatePicker() {
    return <Fragment>
      <Row>

        {this.renderSingleDateDropdown("year", "Year")}

        {this.renderSingleDateDropdown("month", "Month")}

        {this.renderSingleDateDropdown("day", "Day")}

      </Row>
    </Fragment>
  }

  renderSingleDateDropdown(key, header) {
    let numberJsonArray = [];
    this.state.optionGroups[key].forEach(value => {
      numberJsonArray.push({value: value})
    });

    return <Col xs={4}>
      <div style={{textAlign: "center", fontSize: "10px"}}>{header}</div>
      <DropdownComponent
        className={"browser_dropdown"}
        value={this.state.valueGroups[key] !== undefined ? this.state.valueGroups[key] : ""}
        options={numberJsonArray}
        optionValue={"value"}
        optionText={"value"}
        placeholder={key}
        onChange={(selectedOption) => {
          if (selectedOption) {
            this.handleChange(key, selectedOption.value);
          }
        }}
      />
    </Col>
  }


}
